import { connect } from "react-redux";

var CoinDetailsModal = require("components/reading/shelves/CoinDetailsModal");
var CoinDisplay = require("components/utility/CoinDisplay");
var QuestionTypes = require("lib/academic/QuestionTypes");

var WritingSelectors = require("lib/selectors/WritingSelectors");
var RosterSelectors = require("lib/selectors/RosterSelectors");

require("reading/shelves/coins_earned_display.scss");

@connect(
	(state, props) => {
		var coinRecords = RosterSelectors.coinRecordsForSubject({ state,
			subjectType: props.subjectType, subjectID: props.subjectID });

		var evaluation = WritingSelectors.evaluationForSubject({
			state, subjectType: props.subjectType, subjectID: props.subjectID
		});

		var selfOpenModal = $wr.getURLParameterByName("showDetails") == "true";

		if (props.subjectType == "Quiz") {
			var subject = WritingSelectors.quiz({ state, id: props.subjectID })
		} else if (props.subjectType == "Answer") {
			var subject = WritingSelectors.answer({ state, id: props.subjectID })			
		}

		return {
			evaluation, selfOpenModal, subject, coinRecords
		}
	}, () => ({})
)
class CoinsEarnedDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
		};
	}

	openCoinDetailsModal(e) {
		$wr.nope(e);
		this.refs.coinsModal.show();
	}

	subjectNoun() {
		if (this.props.subjectType == "Quiz") {
			return "quizzes"
		} else if (this.props.subjectType == "Answer") {
			if (this.props.subject.question_type == QuestionTypes.REVIEW_QUESTION) {
				return "reviews";
			} else {
				return "answers";
			}
		}
	}

	render() {
		var totalCoinsEarned = 0;
		_.map(this.props.coinRecords, function(coinRecord) {
			totalCoinsEarned += coinRecord.change;
		});
		var coinsModal = (
			<CoinDetailsModal ref="coinsModal" coinRecords={ this.props.coinRecords }
				evaluation={ this.props.evaluation }
				subjectNoun={ this.subjectNoun() } subjectID={ this.props.subjectID }
				subject={ this.props.subject }/>
		);
		if (this.props.subject.excluded) {
			var className = "excluded";
		}

		return (
			<div className="hideOnPrint coinsEarnedDisplay">
				<p className={ className }>
					Coins Earned:
					{ " " }
					<CoinDisplay coins={ totalCoinsEarned } height={ 20 } />
					<a href="#" onClick={ this.openCoinDetailsModal }>Details</a>
				</p>
				{ coinsModal }
			</div>
		);
	}

	componentDidMount() {
		if (this.props.selfOpenModal) {
			this.openCoinDetailsModal();
		}
	}
};

CoinsEarnedDisplay.WrappedComponent.propTypes = StrictPropTypes({
	// Quiz, Answer
	subjectType: PropTypes.string.isRequired,
	subjectID: PropTypes.number.isRequired,

	// data from @connect
	coinRecords: PropTypes.array.isRequired,
	selfOpenModal: PropTypes.bool,
	evaluation: PropTypes.object,
	subject: PropTypes.object

});

module.exports = CoinsEarnedDisplay;


// WEBPACK FOOTER //
// ./modules/components/reading/shelves/CoinsEarnedDisplay.js